import FullParagraph from "segments/desktop/core-components/full-paragraph/full-paragraph";
import ProductsHorizontalTimerTabsComponent from "segments/desktop/tabs/layouts/products-horizontal-timer-tabs/products-horizontal-timer-tabs-component.js";
import Title from "segments/desktop/core-components/title/title";
import { ALIGN_TYPES } from "constants/align-types";
import { UI_BORDER_LIGHT_COLOR_NAME } from "styles/color-consts";
import ProductTagsComponent from "./product-tags-component/product-tags-component";
import DefaultProps from "./default-props";
import { useEffect } from "react";
import { StyledTagsByProductHomepageFirstFoldComponent } from "./tags-by-product-homepage-first-fold-component.scss";

const TagsByProductHomepageFirstFoldComponent = (props) => {
  const {
    tabs,
    fullParagraph,
    fullParagraphAdvancedConfig,
    subTitle,
    subTitleAdvancedConfig,
    tabsPaddingTop,
    isV2,
    excludeFromWMHighIntentExperienceTest,
    translate,
    setIsFirstFoldVisible,
    setStartShowingContactSalesButton,
    isInView
  } = props;

  useEffect(() => {
    if (isInView === true) {
      setStartShowingContactSalesButton(true);
    }
    setIsFirstFoldVisible(isInView);
  }, [setIsFirstFoldVisible, isInView, setStartShowingContactSalesButton]);

  const contentRenderer = (currentTab) => {
    return (
      <ProductTagsComponent
        currentTab={currentTab}
        isV2={isV2}
        excludeFromWMHighIntentExperienceTest={excludeFromWMHighIntentExperienceTest}
        translate={translate}
      />
    );
  };

  return (
    <StyledTagsByProductHomepageFirstFoldComponent className="tags-by-product-homepage-first-fold-component">
      <div className="paragraph-wrapper">
        <FullParagraph
          {...fullParagraphAdvancedConfig}
          {...fullParagraph}
          topic={{}}
          textAlign={ALIGN_TYPES.CENTER}
          titleClassName="universe-title"
        />
        {subTitle?.title && <Title {...subTitle} {...subTitleAdvancedConfig} titleClassName="sub-title" />}
      </div>
      <div className="product-tabs-wrapper" style={{ paddingTop: tabsPaddingTop }}>
        <ProductsHorizontalTimerTabsComponent
          contentRenderer={contentRenderer}
          overrideTabs={tabs}
          tabsTitle={{}}
          progressbarColor={UI_BORDER_LIGHT_COLOR_NAME}
          renderDesktopTabsOnly={true}
        />
      </div>
    </StyledTagsByProductHomepageFirstFoldComponent>
  );
};

TagsByProductHomepageFirstFoldComponent.defaultProps = DefaultProps;

export default TagsByProductHomepageFirstFoldComponent;
